<div class="list-of-needs-dialog" #listOfNeedsDialog>
  <div #stickySentinel class="list-sticky-sentinel"></div>
  <div class="list-sticky-top list-section" [class.stuck]="isStickyTopStuck">
    <div class="dialog-header">
      <mat-icon
        svgIcon="list-of-needs-icon"
        class="list-of-needs-icon"></mat-icon>
      <h2 class="title">Bedarfsliste erfassen</h2>
      <app-modal-close-button
        class="close-button"
        [closeDialog]="closeDialog.bind(this)"></app-modal-close-button>
    </div>
    <div class="resident-selection">
      <div class="flex gap-16px align-end">
        <div class="flex column gap-16px">
          <span>Bewohner für den Sie einkaufen</span>
          <mat-form-field
            appearance="outline"
            class="select"
            [class.panel-open]="select.panelOpen">
            <mat-select
              [formControl]="residentControl"
              placeholder="Bewohner auswählen"
              #select
              panelClass="select-panel">
              <mat-select-trigger>
                <app-profile-avatar
                  [name]="residentControl.value?.getName()"
                  [color]="residentControl.value?.color"
                  [image]="residentControl.value?.image"
                  [size]="35"></app-profile-avatar>
                <span>
                  {{ residentControl.value?.fname }}
                  {{ residentControl.value?.lname }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let resident of selectedDepartment?.people"
                class="flex align-center gap-12px"
                style="padding: 0 8px"
                [value]="resident">
                <app-profile-avatar
                  [name]="resident.getName()"
                  [color]="resident.color"
                  [image]="resident.image"
                  [size]="35"></app-profile-avatar>
                <span>{{ resident.fname }} {{ resident.lname }}</span>
              </mat-option>
            </mat-select>
            <mat-icon matSuffix class="arrow-icon" svgIcon="back-icon">
              expand_more
            </mat-icon>
          </mat-form-field>
        </div>
        <div class="flex column space-between" style="height: 50px">
          <div class="flex gap-12px align-center">
            <app-sepa-check></app-sepa-check>
            <app-resident-budget
              [resident]="residentControl.value"
              [showAddBudget]="true"
              theme="dark"
              *ngIf="residentControl.value"
              (click)="closeDialog()"></app-resident-budget>
          </div>
          <div
            style="display: flex; align-items: center; gap: 8px"
            *ngIf="selectedDepartment">
            <img [src]="selectedDepartment.iconUrl" class="department-icon" />
            <p class="department-name text-trim">
              {{ selectedDepartment.name }}
            </p>
          </div>
        </div>
      </div>
      <div class="flex justify-end" style="margin-bottom: -10px">
        <div
          class="flex column justify-end gap-4px total-container"
          style="margin-bottom: 12px">
          <span>Auf der Liste</span>
          <span class="total">€ {{ listTotal | number: '1.2-2' }}</span>
        </div>
        <div class="list" style="cursor: pointer">
          <mat-icon
            svgIcon="bedarfsliste-icon"
            class="bedarfsliste-icon"></mat-icon>
          <div class="items-count-container">
            <p
              class="items-count text-trim"
              [ngStyle]="{
                '--digitCount': (listNumberOfItems || 0).toString().length
              }">
              {{ listNumberOfItems || 0 }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-list-section
    style="max-width: 100%"
    [selectedProducts]="selectedProducts"
    [residentControl]="residentControl"
    [listTotal]="listTotal"
    [listNumberOfItems]="listNumberOfItems"
    (productSelected)="onProductSelected($event)"
    (productRemoved)="onProductRemoved($event)"
    (updateQuantity)="updateQuantity($event)"
    [addProductsToCart]="addProductsToCart.bind(this)"
    [closeDialog]="closeDialog.bind(this)"></app-list-section>
  <app-cart-section
    [residentControl]="residentControl"
    [residentCart]="residentCart"
    [closeDialog]="closeDialog.bind(this)"></app-cart-section>
</div>
